<template>
  <SeoBlogArticle :content="$t('seoArticleOQueEUtmContent')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleOQueEUtmContent',
  components: { SeoBlogArticle },
}
</script>
